import React, { useMemo, useState } from 'react';
import { Container, Dropdown, Nav, Navbar } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { dashboardPathForRole, useAuth } from '../context/AuthContext';
import { apiPost } from '../services/api';

function Header() {
  const { user, token, authLoading, logout, apiBase } = useAuth();
  const navigate = useNavigate();
  const [loggingOut, setLoggingOut] = useState(false);

  const displayName = useMemo(() => {
    if (!user) return '';
    if (user.name && String(user.name).trim() !== '') return user.name;
    return user.email || 'Account';
  }, [user]);

  async function handleLogout() {
    if (!apiBase) {
      logout();
      navigate('/', { replace: true });
      return;
    }
    setLoggingOut(true);
    try {
      await apiPost('/api/v1/auth/logout', {}, token);
    } finally {
      logout();
      setLoggingOut(false);
      navigate('/', { replace: true });
    }
  }

  return (
    <header>
      <Navbar expand="lg" className="bg-body-tertiary" data-testid="rwm-navbar">
        <Container>
          <Navbar.Brand as={Link} to="/">
            <img
              src="/remote-work-market.png"
              width="172"
              height="60"
              className="d-inline-block align-top"
              alt="Remote Work Market"
            />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto align-items-lg-center">
              <Nav.Link as={Link} to="/jobs" className="nav-link">
                Browse Jobs
              </Nav.Link>
              {!authLoading && !user ? (
                <>
                  <Nav.Link as={Link} to="/login" className="nav-link">
                    Log In
                  </Nav.Link>
                  <Nav.Link as={Link} to="/register" className="nav-link">
                    Sign Up
                  </Nav.Link>
                </>
              ) : null}
              {!authLoading && user ? (
                <Dropdown align="end" className="ms-lg-2">
                  <Dropdown.Toggle
                    variant="light"
                    id="rwm-user-menu"
                    disabled={loggingOut}
                    data-testid="rwm-navbar-user-menu"
                  >
                    {displayName}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item as={Link} to={dashboardPathForRole(user.role)}>
                      Dashboard
                    </Dropdown.Item>
                    <Dropdown.Divider />
                    <Dropdown.Item
                      onClick={handleLogout}
                      disabled={loggingOut}
                      data-testid="rwm-navbar-logout"
                    >
                      {loggingOut ? 'Logging out…' : 'Log Out'}
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              ) : null}
              <Nav.Link
                as={Link}
                to="/for-companies"
                className="nav-link btn btn-for-companies btn-sm ms-lg-2"
                data-testid="rwm-nav-for-companies"
              >
                For Companies
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>
  );
}

export default Header;
